// extracted by mini-css-extract-plugin
export var text = "_9n-0";